export const typeOptions = [
  { label: "Transcrito", value: "transcrito" },
  { label: "Áudio Web", value: "audio" }
]

export const fileType = [
  { value: "PDF", type: "transcrito" },
  { value: "WEB", type: "audio" }
]



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/AudioRequest/constants.js